module.exports = __webpack_public_path__ + "img/logo.cfbf8961.png";